import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { TraversalResponseModel } from 'projects/Administration/src/app/business-entities/checkin-user-model';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { CheckinUserService } from 'projects/Administration/src/app/business-services/checkin-user.service';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';

@Component({
  selector: 'app-check-in-traversal-log',
  templateUrl: './check-in-traversal-log.component.html'
 
})
export class CheckInTraversalLogComponent implements OnInit {
  @Input() workOrderNo: string;
  traversalList:TraversalResponseModel[] = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  debounceTimer;
  constructor(
    private activeModal: NgbActiveModal,
    private checkInUserService: CheckinUserService,
    private pagerService: PaginationService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.traversalList = [];
    this.checkInUserService.traversalListRequest.startRecordNumber = 0;
    this.checkInUserService.traversalListRequest.workOrderNo = this.workOrderNo;
    this.GetCheckinTraversalList();
  }

  async GetCheckinTraversalList() {
    this.spinner.show();
    await this.checkInUserService
      .GetCheckinTraversalList(this.checkInUserService.traversalListRequest)
      .then(
        (response) => {
          this.spinner.hide();
          this.traversalList.push(...response.responseObject);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            if(this.traversalList?.length > 0){
              this.traversalList?.forEach(x => {
                if(x?.traversedDate){
                  x.traversedDate = x.traversedDate ? new Date(x.traversedDate + 'Z') : null;
                }
              })
            }
            this.totalCount =
              this.traversalList.length > 0
                ? this.traversalList[0].totalCount
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.traversalList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  loadMoreData(event){
    this.debounceFunction(()=>this.onScrollDown(event),200);
  }

  debounceFunction(func,delay){
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
     if (this.totalCount > this.traversalList?.length) {
       this.checkInUserService.traversalListRequest.startRecordNumber = this.traversalList.length
       this.GetCheckinTraversalList();
     }
  }

  OnClose() {
    this.activeModal.close({ success: false })
  }

}
